<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--购物车content-->
      <div>
        <p class="group_title zt14" v-if="!emptyCart">{{productStoreName}}
          <button @click="" class="clear_style fr zt14" @click="changeIsEdit(isEdit)">{{isEdit == true?"完成":"编辑"}}</button>
        </p>
        <div class="cart_group_item" v-if="!emptyCart" v-for="(produtGroupItem, groupIndex) in productGroupList" :key="groupIndex">
          <div>
            <p class="zt12 group_promote black clear_both" v-if="produtGroupItem.productPromo.promoName"><span class="fl zt12 group_promote_tag">{{produtGroupItem.productPromo.promoRule}}</span>{{produtGroupItem.productPromo.promoName}}</p>
            <div  class="clear_both" style="padding: 0.5rem 0.5rem;border-bottom: 1px solid #E7E7E7;" v-for="(productItem,productIndex) in produtGroupItem.productList" :key="productIndex">
              <button class="fl group_item_select" @click="cartIsAllCheck('selected',productItem.productId,productItem.isSelect)" v-if="!productItem.isPromo">
                <img class="group_item_select_btn"  :src="productItem.isSelect== 'Y'?require('@/images/icon_Selected@3x.png'):require('@/images/icon_Unselected@3x.png')">
              </button>
              <van-image class="full_w fl group_item_img" v-if="!productItem.isPromo"  fit="cover" :src="productItem.imgUrl" />
              <div class="fl group_item_name" v-if="!productItem.isPromo" >
                <p class="zt14 clear_style black" style="height: auto">{{productItem.productName}}</p>
                <p class="clear_style fl zt12 group_item_feature" @click="showSpec(productItem,productItem.productFeatureList)"><span v-show="productItem.productFeatureList.length > 0" class="fl" style="background-color: #f5f5f5;padding: 0.1rem 0.3rem">{{getFeatureString(productItem.productFeatureList)}}<img class="fr" style="width: 0.8rem;height: 0.8rem;margin-top: 0.1rem;margin-left: 0.5rem" src="@/images/cart_feature_down.png"></span></p>
                <div class="clear_both">
                  <span class="fl zt14" style="line-height: 1.8rem;color: #EB84AB">¥{{productItem.price.toFixed(2)}}</span>
                  <div class="fr">
                    <span class="fl tc black zt16 group_item_num_btn" :class="productItem.quantity == 1? 'reduce_disabled_btn':''" @click="updateCartProduct('reduce',productItem.quantity,productItem.catalogId,productItem.productId,productItem.shoppingListItemSeqId)">-</span>
                    <div class="fl"><input type="tel" class="zt14 black tc group_item_val_btn" disabled="disabled" :value="productItem.quantity"></div>
                    <span class="fl tc black zt16 group_item_num_btn" @click="updateCartProduct('add',productItem.quantity,productItem.catalogId,productItem.productId,productItem.shoppingListItemSeqId)">+</span>
                  </div>
                </div>
              </div>
              <p class="clear_style fl black zt12" v-if="productItem.isPromo" style="padding: 0rem 1rem;width: 20rem">赠品:{{productItem.productName}}<router-link :to="{path:'/collectBills',query:{shoppingListItemSeqId:productItem.shoppingListItemSeqId}}"><span class="fr zt12 group_item_zengpin_btn">换赠品</span></router-link></p>
            </div>
          </div>
          <div v-if="guessProductList.length > 0 && groupIndex == guessProductList.length - 1" style="height: 0.5rem;background-color: #f5f5f5" class="full_w"></div>
        </div>
        <div v-if="emptyCart" class="zt14 black tc" style="padding: 3rem 0">
          <p>购物车是空的，开启购物之旅吧</p>
          <div>
            <router-link to="/home">
              <van-button round color="#EB84AB" size="small" type="info" >去首页看看</van-button>
            </router-link>
          </div>
        </div>
      </div>
      <!--otherList-->
      <div>
        <div class="cart_group_item" v-for="(produtGroupItem, groupIndex) in otherPromoList" :key="groupIndex">
          <div>
            <p class="zt12 group_promote black clear_both" v-if="produtGroupItem.productList.length > 0"><span class="fl zt12 group_promote_tag">{{produtGroupItem.productPromo.promoRule ==""?'类型':produtGroupItem.productPromo.promoRule}}</span>{{produtGroupItem.productPromo.promoName}}</p>
            <div  class="clear_both" style="padding: 0.5rem 0.5rem;border-bottom: 1px solid #E7E7E7;" v-for="(productItem,productIndex) in produtGroupItem.productList" :key="productIndex">
              <button class="fl group_item_select" @click="cartIsAllCheck('selected',productItem.productId,productItem.isSelect)" v-if="!productItem.isPromo">
                <img class="group_item_select_btn"  :src="productItem.isSelect== 'Y'?require('@/images/icon_Selected@3x.png'):require('@/images/icon_Unselected@3x.png')">
              </button>
              <van-image class="full_w fl group_item_img" v-if="!productItem.isPromo"  fit="cover" :src="productItem.imgUrl" />
              <div class="fl group_item_name" v-if="!productItem.isPromo" >
                <p class="zt14 clear_style black" style="height: auto">{{productItem.productName}}</p>
                <p class="clear_style fl zt12 group_item_feature"><span v-show="productItem.productFeatureList.length > 0" class="fl" style="background-color: #f5f5f5;padding: 0.1rem 0.3rem">已选择:{{getFeatureString(productItem.productFeatureList)}}<img class="fr" style="width: 0.8rem;height: 0.8rem;margin-top: 0.1rem;margin-left: 0.5rem" src="@/images/cart_feature_down.png"></span></p>
                <div class="clear_both">
                  <span class="fl zt14" style="line-height: 1.8rem;color: #EB84AB">¥{{productItem.price.toFixed(2)}}</span>
                  <div class="fr">.
                    <span class="fl tc black zt16 group_item_num_btn" :class="productItem.quantity == 1? 'reduce_disabled_btn':''" @click="updateCartProduct('reduce',productItem.quantity,productItem.catalogId,productItem.productId,productItem.shoppingListItemSeqId)">-</span>
                    <div class="fl"><input type="tel" class="zt14 black tc group_item_val_btn" disabled="disabled" :value="productItem.quantity"></div>
                    <span class="fl tc black zt16 group_item_num_btn" @click="updateCartProduct('add',productItem.quantity,productItem.catalogId,productItem.productId,productItem.shoppingListItemSeqId)">+</span>
                  </div>
                </div>
              </div>
              <p class="clear_style fl black zt12" v-if="productItem.isPromo" style="padding: 0rem 1rem;width: 20rem">赠品:{{productItem.productName}}<router-link :to="{path:'/collectBills',query:{shoppingListItemSeqId:productItem.shoppingListItemSeqId}}"><span class="fr zt12 group_item_zengpin_btn">换赠品</span></router-link></p>
            </div>
          </div>
          <div v-if="guessProductList.length > 0 && groupIndex == groupIndex == guessProductList.length - 1" style="height: 0.5rem;background-color: #f5f5f5" class="full_w"></div>
        </div>
      </div>

      <!--猜你喜欢-->
      <div v-if="guessProductList.length > 0">
        <p class="tc zt14 black">— 猜你喜欢 —</p>
        <div class="clear_both" style="padding-bottom: 3rem">
          <div class="pl_info1 fl" v-for="(productItem, productIndex) in guessProductList" :key="productIndex">
            <router-link :to="{name:'goodsDetail',query:{goodsId:productItem.productId}}">
              <van-image class="pl_info1_img" fit="cover" :src="productItem.imageUrl"/>
            </router-link>
            <p class="pl_info1_title">{{productItem.productName}}</p>
            <span  class="pl_info1_price fl">¥{{productItem.price}}</span>
            <span class="pl_info1_addCart fr">{{productItem.quantity}}人付款</span>
          </div>
        </div>
      </div>

      <!--分界线-->
      <div class="base_line"></div>

      <!--结算-->
      <div class="balance_view">
        <div class="fl clear_style clear_both zt14 black all_check_btn" @click="cartIsAllCheck('allSelected','',allCheck)">
          <img class="group_item_select_btn" style="margin-top: 1rem;position: absolute" :src="allCheck == true?require('@/images/icon_Selected@3x.png'):require('@/images/icon_Unselected@3x.png')">
          <span style="padding-left: 1.5rem">全选</span>
        </div>
        <van-button class="fr" v-show="!isEdit" ref="jiesuanBtn" color="#AF97E7" :disabled="emptyCart" style="width: 7rem;height: 3rem" :loading="nextStepLoading" type="primary" loading-text="结算中" @click="orderComfirmAction()" >结算</van-button>
        <p v-show="!isEdit" class="fr zt14 black" style="margin-right: 1rem">合计:<span class="zt16 total_price_view">¥{{totalPrices.toFixed(2)}}</span></p>
        <van-button v-show="isEdit" ref="deleteBtn" @click="deleteCartProduct()" :disabled="emptyCart" class="fr" color="#AF97E7" style="position: absolute;right: 0;width: 7rem;height: 3rem" type="primary" >删除</van-button>
      </div>

      <!--规格-->
      <div>
        <!--规格上拉菜单-->
        <div ref="markView" class="goods-action-spec-shadow" @click="hideSpec()"></div>
        <div ref="specView" class="goods-action-spec-content animate_action">
          <div class="goods-action-spec-goods">
            <div class="goods-action-spec-goodsImg">
              <van-image :src="product.image" fit="cover"></van-image>
            </div>
            <div class="goods-action-spec-goodsInfo">
              <div class="goods-action-spec-goodsInfo-price">
                ¥{{product.price}}
              </div>
              <div class="goods-action-spec-goodsInfo-stock">
                库存:{{product.repertory}}
              </div>
              <div class="goods-action-spec-goodsInfo-spec">
                已选:{{product.featDesc}}
              </div>
            </div>
          </div>
          <div class="goods-action-spec-list">
            <loading v-show="specLoading"></loading>
            <div class="goods-action-spec-list-each" v-for="(feature,index) in  productFeature" :key="index" v-show="!specLoading">
              <div class="goods-action-spec-list-each-title">
                {{feature.description}}
              </div>
              <div class="goods-action-spec-list-each-list">
                <button v-for="(each,index) in feature.productFeatureList" :key="index" @click="choiceFeature(feature.productFeatureTypeId,each.productFeatureId,each.enable,currentProductInfo.parentProductId)"
                        :class="[each.status==1?'goods-action-spec-list-each-list-choice':each.status==2?'goods-action-spec-list-each-list-noChoice':'goods-action-spec-list-each-list-noAblechoice']">
                  {{each.description}}
                </button>
              </div>
            </div>
          </div>
          <div class="goods-action-spec-button">
            <button @click="addCar()">确定</button>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getShoppingCartInfo,getGuessLike,cartIsAllCheck,deleteCartProduct,updateCartProduct,getProductFeature,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

export default {
  name: 'cart',
  data() {
    return {
      token:"",
      productStoreId:storeName,
      prodCatalogId:prodCatalogId,
      catNum:0,
      productGroupList:[],
      otherPromoList:[],
      guessProductList:[],
      totalPrices:0,
      allCheck:false,
      allUnCheck:false,
      isEdit:false,
      deleteProductStr:"",
      productStoreName:"",
      specLoading:true,
      paramsLoading:true,
      product: {},
      productFeature: [],
      currentProductInfo:'',
      featureNum:0,
      emptyCart:true,
      showLoading:true,
      nextStepLoading:false,
    }
  },
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    footerView,
    loading,
    refresh
  },
  methods:{
    async initData() {
      console.log("storeName:"+storeName)
      console.log("productStoreId========="+this.productStoreId)
      this.getShoppingCartInfo();
      this.getGuessLike();
      if (this.$route.query.fromUrl) {
        setStore('giveAway',true)
      }
    },
    getShoppingCartInfo() {
      console.log({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId})
      getShoppingCartInfo({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId})
        .then(res => {
          console.log("getShoppingCartInfo")
          console.log(res)
          console.log(JSON.stringify(res))
          this.refreshData(res)
          setTimeout(() => {
            this.showLoading = false;
          }, 1000);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getGuessLike() {
      getGuessLike({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
        .then(res => {
          console.log("getGuessLike")
          console.log(res)
          console.log(JSON.stringify(res))
          this.guessProductList = res.productList
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 全选或全反选
    cartIsAllCheck(type,productId,isAllCheck){
      if (type == 'selected') {             // 单个产品选择或删除
        if (isAllCheck == 'N') {
          isAllCheck = 1;
        } else {
          isAllCheck = 2;
        }
      } else if (type == 'allSelected') {   // 全选商品及反选
        if (isAllCheck == false) {
          isAllCheck = 1;
        } else {
          isAllCheck = 2;
        }
      }
      cartIsAllCheck({externalLoginKey:getStore('externalLoginKey'),isAllCheck:isAllCheck,productStoreId:storeName,productId:productId,prodCatalogId:prodCatalogId})
        .then(res => {
          console.log("cartIsAllCheck")
          console.log(res)
          this.refreshData(res)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 购物车调整数量和规格详情
    updateCartProduct (type,cnt,catalogId,productId,shoppingListItemSeqId){
      if (type == "reduce") {
        if (cnt > 1) {
          cnt -= 1;
        } else {
          Toast('已是最小数量')
        }
        productId = ""
      } else if(type == 'add') {
        cnt += 1;
        productId = ""
      } else if (type == 'feature') {

      }
      updateCartProduct({externalLoginKey:getStore('externalLoginKey'),prodCatalogId:catalogId,quantity:cnt,productId:productId,productStoreId:storeName,shoppingListItemSeqId:shoppingListItemSeqId})
        .then(res => {
          console.log("updateCartProduct")
          console.log(res)
          this.refreshData(res)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 删除购物车里面的商品
    deleteCartProduct () {
      deleteCartProduct({externalLoginKey:getStore('externalLoginKey'),shoppingListItemSeqIdList:this.deleteProductStr,productStoreId:storeName,prodCatalogId:prodCatalogId})
        .then(res => {
          console.log("deleteCartProduct")
          console.log(res)
          Toast(res._EVENT_MESSAGE_)
          this.refreshData(res)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 调整编辑和删除购物车
    changeIsEdit(isEidt) {
      this.isEdit = !isEidt
      this.deleteProductStr = ""
      this.refreshDeleteProductStr(this.productGroupList)
    },
    // 规格属性拼接
    getFeatureString(featureList) {
      var featureString = ""
      if (featureList.length > 1) {
        for(var i=0;i<featureList.length;i++) {
          if (i == featureList.length-1) {
            featureString += featureList[i].productFeatureDescription
          } else {
            featureString += featureList[i].productFeatureDescription + "、"
          }
        }
      } else {
        for(var i=0;i<featureList.length;i++) {
          featureString += featureList[i].productFeatureDescription
        }
      }
      return featureString;
    },
    refreshDeleteProductStr(productGroupList) {
      this.deleteProductStr = ""
      var deleteProductArr = []
      // 删除已勾选的内容,except赠品
      for (var i=0;i<productGroupList.length;i++) {
        for (var index=0;index<productGroupList[i].productList.length;index ++){
          if (productGroupList[i].productList[index].isSelect == 'Y' && productGroupList[i].productList[index].isPromo == false) {
            deleteProductArr.push(productGroupList[i].productList[index])
          }
        }
      }
      for (var item=0;item<deleteProductArr.length;item++){
        if (item == 0) {
          this.deleteProductStr += deleteProductArr[item].shoppingListItemSeqId
        } else {
          this.deleteProductStr += "," + deleteProductArr[item].shoppingListItemSeqId
        }
      }
      console.log("deleteProductStr" + this.deleteProductStr)
    },
    // refreshData
    refreshData (res) {
      if (res._ERROR_MESSAGE_) {
        Toast(res._ERROR_MESSAGE_);
      }
      if (res.productGroupList.length>0){

      }

      this.productGroupList = res.productGroupList
      this.otherPromoList = res.otherPromoList;
      this.totalPrices = res.totalPrices;
      this.productStoreName = res.productStoreName;
      this.allCheck = true;
      this.allUnCheck = true
      this.emptyCart = false;
      this.emptyCartList(res);
      for (var i=0;i<this.productGroupList.length;i++) {
        for (var index=0;index < this.productGroupList[i].productList.length;index ++){
          if (this.productGroupList[i].productList[index].isSelect == 'N' && this.productGroupList[i].productList[index].isPromo == false) {
            this.allCheck = false
          }
          // 判断购物车有商品的情况下会出现计算运费的情况
          if (this.productGroupList[i].productList[index].isSelect == 'Y') {
            this.allUnCheck = false
          }
          if (index < this.productGroupList[i].productList.length - 1) {
            console.log(11111)
            console.log(this.productGroupList[i].productList[index])
            console.log(22222)
            console.log(this.productGroupList[i].productList[index + 1])
            if (this.productGroupList[i].productList[index].isPromo == true && this.productGroupList[i].productList[index + 1].isPromo == false) {
              var a = this.productGroupList[i].productList[index]
              var b = this.productGroupList[i].productList[index + 1]
              this.productGroupList[i].productList[index] = b
              this.productGroupList[i].productList[index + 1] = a
            }
          }
        }
      }
      // 如果购物车里所有的东西全部没选，运费去掉
      if (this.allUnCheck == true) {
        this.totalPrices = 0
      }
      this.refreshDeleteProductStr(this.productGroupList)
    },
    // 显示规格
    showSpec: function (productInfo,arr) {
      this.currentProductInfo = productInfo
      if (arr.length > 0) {
        this.changeFeature('', '',productInfo.parentProductId)
        this.$refs.markView.style.bottom = '0px'
        this.$refs.markView.style.display = 'block'
        this.$refs.specView.style.bottom = '0px'
        this.specLoading = true
      } else {
        return
      }
    },
    // emptyList
    emptyCartList(res) {
      if (this.totalPrices == 0) {
        this.emptyCart = true
      }
      if (res.productGroupList.length > 0) {
        for(var i=0;i<res.productGroupList.length;i++) {
          if (res.productGroupList[i].productList.length > 0) {
            this.emptyCart = false
          }
        }
      } else {
        this.emptyCart = true
      }
    },
    // 隐藏规格
    hideSpec: function () {
      this.$refs.markView.style.bottom = -window.innerHeight + 'px'
      this.$refs.specView.style.bottom = -window.innerHeight + 'px'
      this.paramsLoading = false
    },

    // 用户选择规格
    choiceFeature: function (typeId, featureId, enable,productId) {
      this.specLoading = true
      if (enable != 'N') {
        var feature = ''
        for (var i = 0; i < this.productFeature.length; i++) {
          for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
            if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
              feature += this.productFeature[i].productFeatureTypeId + ',' + this.productFeature[i].productFeatureList[j].productFeatureId + '|'
            }
          }
        }
        this.changeFeature(typeId + ',' + featureId, feature.substring(0,feature.length-1),productId)
      } else {
        Toast('当前无此规格商品')
        this.specLoading = false
      }
    },
    // 用户修改规格
    changeFeature: function (nowFeature, feature,productId) {
      let param = {
        productId: productId,
        productStoreId: storeName,
        nowFeature: nowFeature,
        feature: feature,
        prodCatalogId:prodCatalogId,
      }
      getProductFeature(param).then( res=> {
        console.log(res)
        this.productFeature = res.featureList
        for(var i = 0;i<this.productFeature.length;i++){
          for(var j = 0;j<this.productFeature[i].productFeatureList.length;j++){
            if(this.productFeature[i].productFeatureList[j].enable=='Y'&&this.productFeature[i].productFeatureList[j].isSelect=='Y'){
              this.productFeature[i].productFeatureList[j].status = 1
            }else if(this.productFeature[i].productFeatureList[j].enable=='Y'&&this.productFeature[i].productFeatureList[j].isSelect=='N'){
              this.productFeature[i].productFeatureList[j].status = 2
            }else if(this.productFeature[i].productFeatureList[j].enable=='N'){
              this.productFeature[i].productFeatureList[j].status = 3
            }
          }
        }
        this.product = res.product
        this.getChoiceFeature()
        this.specLoading = false
      }).catch(err => {
        console.log(err)
        this.specLoading = false
        Toast('获取失败')
      })
    },
    //获取用户所选规格名称
    getChoiceFeature:function(){
      var featDesc = ''
      for (var i = 0; i < this.productFeature.length; i++) {
        for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
          if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
            featDesc += this.productFeature[i].productFeatureList[j].description + ','
          }
        }
        this.product.featDesc = featDesc.substring(0, featDesc.length - 1)
      }
    },
    //用户点击规格确定按钮
    addCar:function () {
      this.featureNum = 0
      for (var i = 0; i < this.productFeature.length; i++) {
        for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
          if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
            this.featureNum ++
          }
        }
      }
      if(this.featureNum == this.productFeature.length){
        this.updateCartProduct('feature',this.currentProductInfo.quantity,this.currentProductInfo.catalogId,this.product.productId,this.currentProductInfo.shoppingListItemSeqId)
        this.hideSpec();
      }else{
        Toast({message:'您还没有选择商品规格'})
      }
    },
    orderComfirmAction() {
      this.nextStepLoading = true;
      setTimeout(() => {
        this.$router.push({path:'/orderComfirm'})
      }, 1000);
    },
    // 数据格式化
    resetScorllView() {
      this.$router.afterEach((to,from, next) => {
        window.scrollTo(0,0)
      })
    }
  },
  mounted() {
    this.initData();
    this.resetScorllView();
  }

}
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-bottom: 0;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding-top: 2.5rem
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 16rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.5rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  /*商品规格*/
  .goods-action-spec-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: none;
    z-index: 99;
  }
  .goods-action-spec-content{
    width:100%;
    height:31.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    z-index: 99;
  }
  .goods-action-spec-goods{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .goods-action-spec-goodsImg{
    width:6.25rem;
    height: 6.25rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
  }
  .goods-action-spec-goodsImg .van-image{
    width:100%;
    height: 100%;
  }
  .goods-action-spec-goodsInfo{
    width:calc(100% - 7.25rem);
    display: inline-block;
    vertical-align: top;
  }
  .goods-action-spec-goodsInfo-price{
    font-size:1rem;
    color:#333312;
    margin-bottom: 1.25rem;
  }
  .goods-action-spec-goodsInfo-stock{
    font-size: 0.875rem;
    color:#666;
    margin-bottom: 0.625rem;
  }
  .goods-action-spec-goodsInfo-spec{
    font-size: 0.875rem;
    color:#666;
  }
  .goods-action-spec-list{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-action-spec-list-each{
    width:100%;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-spec-list-each-title{
    font-size: 1rem;
    color:#333312;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
  .goods-action-spec-list-each-list{
    width:100%;
  }
  .goods-action-spec-list-each-list div{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .goods-action-spec-list-each-list button{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }

  .goods-action-spec-list-each-list-noChoice{
    border: 1px solid #999;
    color: #333312;
  }
  .goods-action-spec-list-each-list-choice{
    border: 1px solid #EB84AB;
    color: #EB84AB;
  }
  .goods-action-spec-list-each-list-noAblechoice{
    border: 1px solid #e5e5e5;
    color: #e5e5e5;
  }
  .goods-action-spec-num{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-action-spec-num button{
    display: inline-block;
    vertical-align: top;
    /*height: 1.5rem;*/
    line-height: 1.5rem;
    border-radius: 0.1rem;
    border: 1px solid #999;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    color: #333312;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    text-align: center;
  }
  .goods-action-spec-num div{
    display: inline-block;
    vertical-align: top;
    font-size: 1rem;
    color:#333312;
    margin-right: 0.625rem;
  }
  .goods-action-spec-button{
    width:18.75rem;
    margin: 0 auto;

  }
  .goods-action-spec-button button{
    width:18.75rem;
    position: absolute;
    bottom: 0.5rem;
    background-color: deeppink;
    color:white;
    font-size:1rem;
    text-align: center;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 2rem;
  }

  .animate_action {
    transition:all .4s;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/cart/cart.vue